import { render } from "./TheHeaderLg.vue?vue&type=template&id=04b29a65&scoped=true"
import script from "./TheHeaderLg.vue?vue&type=script&lang=js"
export * from "./TheHeaderLg.vue?vue&type=script&lang=js"

import "./TheHeaderLg.vue?vue&type=style&index=0&id=04b29a65&scoped=true&lang=css"

import exportComponent from "F:\\online.ug\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b29a65"]])

export default __exports__